import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import useScrollReveal from '../hooks/useScrollReveal';
import './ReferencesBanner.css';

const ReferencesBanner = () => {
  const { t } = useLanguage();
  const logos = [
    { src: '/img/1.png', alt: 'N', scale: 1  },
    { src: '/img/2.png', alt: 'Heilpflanzenwohl' },
    { src: '/img/3.png', alt: 'Kunde 3' },
    { src: '/img/4.png', alt: 'Ironmax', scale: 1.5 },
    { src: '/img/17.png', alt: 'LILI Liposomal Liquids', scale: 0.75 },
    { src: '/img/5.png', alt: 'Kerbholz', scale: 1.3 },
    { src: '/img/6.png', alt: 'BB', scale: 1.3 },
    { src: '/img/16.png', alt: 'Fö' },
    { src: '/img/7.png', alt: 'Flavio Simonetti' , scale: 1.3 },
    { src: '/img/8.png', alt: 'Kunde 8' , scale: 1.3},
    { src: '/img/15.png', alt: 'Keimling Naturkost', scale: 0.75 },
    { src: '/img/9.png', alt: 'Kunde 9' , scale: 1.25  },
    { src: '/img/10.png', alt: 'Kunde 10' },
    { src: '/img/14.png', alt: 'buxtrade', scale: 0.75},
    { src: '/img/11.png', alt: 'Kunde 11' },
    { src: '/img/13.png', alt: 'buxtrade'},
  ];

  const duplicatedLogos = [...logos, ...logos];
  const sectionReveal = useScrollReveal({ threshold: 0.2 });

  return (
    <section ref={sectionReveal.ref} className={`references-banner-fox reveal--fade ${sectionReveal.isRevealed ? 'reveal--visible' : ''}`}>
      <span className="references-banner-fox__title">{t.referencesBanner.title}</span>
      <div className="references-banner-fox__glow"></div>
      <div className="references-banner-fox__fade references-banner-fox__fade--left"></div>
      <div className="references-banner-fox__fade references-banner-fox__fade--right"></div>
      <div className="references-banner-fox__container">
        <div className="references-banner-fox__track">
          {duplicatedLogos.map((logo, index) => (
            <div key={index} className="references-banner-fox__item">
              <img 
                src={logo.src} 
                alt={logo.alt}
                className="references-banner-fox__logo"
                style={logo.scale ? { transform: `scale(${logo.scale})` } : undefined}
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReferencesBanner;
